export const YOUTUBE_REGEX = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)(?:[&?][\w=&-]*)?/;
export const VIMEO_REGEX = /vimeo\.com\/(\d+)(?:\?[\w=&-]*)?/;
export const YOUTUBE_VIDEO_ID_REGEX = /^[\w-]{11}$/;

export const getEmbeddedVideoUrl = (url) => {
  if (!url) return null;

  // if it is only a video ID, we assume it is a youtube video and return youtube url
  if (YOUTUBE_VIDEO_ID_REGEX.test(url.trim())) {
    return `https://www.youtube.com/embed/${url.trim()}`;
  }

  const youtubeMatch = url.trim().match(YOUTUBE_REGEX);
  const vimeoMatch = url.trim().match(VIMEO_REGEX);

  if (youtubeMatch) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
  }

  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  }

  return url;
};
